// ENUMS FOR ROLES
const rolesTypes = {
    ADMINISTRATOR: 'administrator',
    FINANCIALADMINISTRATOR: 'financialAdministrator',
    MANAGER: 'manager',
    LABMANAGER: 'laboratoryManager',
    LABMICROBIOLOGIST: 'laboratoryMicrobiologist',
    LABCHEMIST: 'laboratoryChemist',
    SALESREP: 'salesRepresentative',
    SALESMANAGER: 'salesManager',
    LABTECH: 'laboratoryTechnician',
    SERVICETECH: 'serviceTechnician',
    OPERATOR: 'operator',
} as const;

// Create a type for the role values
type RoleType = (typeof rolesTypes)[keyof typeof rolesTypes];

type RoleKey = keyof typeof rolesTypes;

export default Object.freeze(rolesTypes);
export { RoleType, RoleKey };
